import React from 'react';
import useConfig from '@hooks/useConfig';
import * as styles from './ErrorMessages.module.scss';
import { formatParagraphs } from '@helpers';
import ErrorIcon from './error.svg';
import classNames from 'classnames';
import { isString } from 'lodash';
import { DEFAULT_ERROR_TITLE, DEFAULT_ERROR_MESSAGE } from '@constants';

export default function ErrorMessagesWrapper({
  messages,
  showRackRatesInvitation,
  fetchRackRateGroups
}) {
  const config = useConfig();
  const rackRatesText = config.showRackRatesMessage?.trim();

  return !messages ? null : (
    <div className={classNames('calculator-errors', styles.wrapper)}>
      <div className="content-wrapper">
        <ErrorMessage
          title={DEFAULT_ERROR_TITLE}
          message={messages}
        >
          {showRackRatesInvitation && (
            <div className={styles.rackRates}>
              <div
                className={styles.rackRatesText}
                dangerouslySetInnerHTML={{ __html: rackRatesText }}
              />
              <button
                className={styles.rackRatesButton}
                onClick={fetchRackRateGroups}
              >
                View Mortgage Rates
              </button>
            </div>
          )}
        </ErrorMessage>
      </div>
    </div>
  );
}

export function ErrorMessage({
  className,
  title = DEFAULT_ERROR_TITLE,
  message,
  children
}) {
  if (isString(message)) {
    if (message.includes('JSON at')) {
      message = DEFAULT_ERROR_MESSAGE;
    }

    message = formatParagraphs(message);
  }

  return (
    <div className={classNames(styles.message, className)}>
      <div className={styles.icon}>
        <ErrorIcon />
      </div>
      <div className={styles.text}>
        {title && <strong className={styles.title}>{title}</strong>}
        {message}
        {children}
      </div>
    </div>
  );
}
